module.exports = __webpack_public_path__ + "static/media/oneday_8.fa57287a.png";